import { ChainId } from '@shibaswap/sdk'
import graphAPIEndpoints from '../constants/subgraphs'

export function graphEndpoint(isMultichain: boolean, chainId?: ChainId, useShibaswapEndpoint?: boolean): string {
    // Ensure graphAPIEndpoints and its properties are not null or undefined
    const defaultEndpoint = graphAPIEndpoints?.multichain?.metaverse || 'defaultMetaverseEndpoint'; // Replace with a suitable default
    const defaultShibaswapEndpoint = graphAPIEndpoints?.ethereum?.shibaswap || 'defaultShibaswapEndpoint'; // Replace with a suitable default

    if (useShibaswapEndpoint) {
        switch (chainId) {
            case ChainId.PUPPYNET:
                return graphAPIEndpoints?.puppynet?.shibaswap || defaultShibaswapEndpoint;
            case ChainId.SHIBARIUM:
                return graphAPIEndpoints?.shibarium?.shibaswap || defaultShibaswapEndpoint;
            case ChainId.MAINNET:
                return graphAPIEndpoints?.ethereum?.shibaswap || defaultShibaswapEndpoint;
            default:
                return defaultShibaswapEndpoint;
        }
    }

    if (isMultichain) {
        return graphAPIEndpoints?.multichain?.metaverse || defaultEndpoint;
    }

    if (!chainId) {
        return graphAPIEndpoints?.multichain?.metaverse || defaultEndpoint;
    }

    switch (chainId) {
        case ChainId.PUPPYNET:
            return graphAPIEndpoints?.puppynet?.metaverse || defaultEndpoint;
        case ChainId.SHIBARIUM:
            return graphAPIEndpoints?.shibarium?.metaverse || defaultEndpoint;
        case ChainId.MAINNET:
            return graphAPIEndpoints?.ethereum?.metaverse || defaultEndpoint;
        default:
            return defaultEndpoint;
    }
}